<template>
  <div class="father">

    <div v-if="screenWidth >= 600" class="needback">
      <div style="margin-bottom:40px;border-bottom:1px solid #ccc;padding-bottom:10px">
        <el-breadcrumb style="font-size:14px" separator=">>">
          <el-breadcrumb-item :to="{ path: '/news' }">资讯动态</el-breadcrumb-item>
          <el-breadcrumb-item> {{news.type == 1 ?' 小鳗动态' : news.type == 2?'行业资讯':'小鳗课堂'}} </el-breadcrumb-item>
        </el-breadcrumb>
      </div>


      <h1>{{ news.title }}</h1>

      <div v-html="news.content" class="content"></div>
      <div class="right" v-if="news.source">
        来源：
        <span style="color: #576b95;">{{ news.source }}</span>
      </div>
      <div class="left">
        <div>
        上一篇：<span @click="toDetailone(list[noeIndex-1])" class="title">{{list[noeIndex-1] ?list[noeIndex-1] .title :'没有了！'}}</span>
        </div>
        <div>
          下一篇：<span  @click="toDetailone(list[noeIndex+1])" class="title">{{list[noeIndex+1] ?list[noeIndex+1] .title :'没有了！'}}</span>
      </div>
      </div>

    </div>

    <div v-else>
      <phone-news-detail />
    </div>
  </div>
</template>

<script>
import phoneNewsDetail from "./phone/phoneNewsDetail.vue";
export default {
  name: "product",
  components: { phoneNewsDetail },
  props: ["to"],
  watch: {
    screenWidth(newValue) {
      // 为了避免频繁触发resize函数导致页面卡顿，使用定时器
      if (!this.timer) {
        // 一旦监听到的screenWidth值改变，就将其重新赋给data里的screenWidth
        this.screenWidth = newValue;
        this.timer = true;
        setTimeout(() => {
          //console.log(this.screenWidth);
          this.timer = false;
        }, 400);
      }
    },
    '$route'(to, from) {
      console.log(111111)
      const timestamp = this.timetep();
      const meta = document.querySelector('meta[name="update_time"]');
      if (meta) {
        meta.setAttribute('content', timestamp);
      } else {
        const newMeta = document.createElement('meta');
        newMeta.setAttribute('name', 'update_time');
        newMeta.setAttribute('content', timestamp);
        document.head.appendChild(newMeta);
      }
      this.params = this.$route.params.id.split("_")[1];
      this.getData();
      this.getNew()
      document.getElementById("main").scroll(0, 0);

    }
  },
  data() {
    return {
      screenWidth: document.body.clientWidth,
      news: "",
      params: "",
      list: [],
      noeIndex: 0
    };
  },
  destroyed() {
    sessionStorage.clear();
  },
  mounted() {
    if (document.getElementById("main")) {
      document.getElementById("main").scroll(0, 0);
    }

    const timestamp = this.timetep();
    const meta = document.querySelector('meta[name="update_time"]');
    if (meta) {
      meta.setAttribute('content', timestamp);
    } else {
      const newMeta = document.createElement('meta');
      newMeta.setAttribute('name', 'update_time');
      newMeta.setAttribute('content', timestamp);
      document.head.appendChild(newMeta);
    }

    window.onresize = () => {
      this.screenWidth = document.body.clientWidth;
    };

    this.params = this.$route.params.id.split("_")[1];
    this.getData();
    this.getNew()
  },

  methods: {
    timetep(){
        const date = new Date();
        const year = date.getFullYear();
        const month = ("0" + (date.getMonth() + 1)).slice(-2);
        const day = ("0" + date.getDate()).slice(-2);
        const hour = ("0" + date.getHours()).slice(-2);
        const minute = ("0" + date.getMinutes()).slice(-2);
        const second = ("0" + date.getSeconds()).slice(-2);
        return `${year}-${month}-${day}T${hour}:${minute}:${second}`;
    },
    toDetailone(item){
      this.$router.push({
        path: '/newDetail/'+ item.type + '_' + item.aid + '.html'
      })
    },
    findNext(id){
      this.list.forEach((ele,index)=>{
        if(ele.aid == this.news.aid){
          this.noeIndex = index
        }
      })
      console.log(this.noeIndex)
    },
    getNew () {
      var params = new URLSearchParams();
      params.append("start", 1);
      params.append("limit", 9999);
      params.append("type",this.$route.params.id.split("_")[0]);
      this.$axios.post("/api/websiteNews/websiteList", params).then(res => {
        this.list = JSON.parse(JSON.stringify(res.data.data.records));
        this.findNext()

      });
    },
    getData() {
      var params = new URLSearchParams();
      params.append("start", 1);
      params.append("limit", 1);
      params.append("aid", this.params.split('.')[0]);
      this.$axios.post("/api/websiteNews/websiteList", params).then(res => {
        this.news = res.data.data.records[0];
        document.title = this.news.title + "「辰鳗科技集团」";
        document
          .querySelector('meta[name="description"]')
          .setAttribute("content", this.news.title + "「辰鳗科技集团」");
      });
    }
  }
};
</script>

<style scoped lang="scss">
.father{
  display: flex;
  align-items: center;
  justify-content: center;
}
.needback{
  font-size: 16px;
    width: 1000px;
    padding: 40px;
    background: #fff;
    box-shadow: 0 2px 10px rgba(54, 97, 174, 0.1);
    border-radius: 8px;
    min-height: 230px;
    margin: 20px;

}
h1 {
  width: 880px;
  margin: 20px auto;
  white-space: wrap;
  text-align: left;
  padding-bottom: 30px;

}
.right {
  text-align: right;
  width: 880px;
  margin: 20px auto 100px;
  font-size: 14px;
}
.left {
  text-align: left;
  width: 880px;
  margin: 20px auto 100px;
  font-size: 15px;
  div{
    margin-top: 15px;
    cursor: pointer;
  }
  .title:hover{
    color: #3170ff;
  }
}

.bannerClass {
  width: 100%;
  color: #ffffff;
  height: 580px;
  background-image: url("../../assets/news/zy1.png");
  background-position: center;
  background-size: cover;
}
.content {
  text-indent: 0 !important;
  min-height: 18px;
  width: 880px;
  margin: auto;
  font-size: 18px;
  color: #0d141e;
  line-height: 1.6667;
  word-wrap: break-word;
  font-family: PingFangSC-Regular;
  text-align: justify;
  letter-spacing: 2px;
  >>> p {
    line-height: 28px;
  }

  >>> p > img {
    width: 100% !important;
    height: 50% !important;
  }
}
</style>
<style>
.ql-align-center {
  text-align: center;
}
.ql-align-left {
  text-align: right;
}
</style>



// WEBPACK FOOTER //
// src/components/page/newDetail.vue